<template>

  <b-sidebar
    id="add-new-chapter-sidebar"
    :visible="isAddNewChapterSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="onSidebarToggle"

  >
  <div class="modal-scroll-wrapper" >


    <template>
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">{{ editChapterData ? 'Edit Module' : 'Add Module' }}</h5>
        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="closeSidebar()" />
      </div>
<div style="
    height: 90vh;
    display: flex;
">
<span style="
    width: 100%;
">
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form class="p-2" @submit.prevent="handleSubmit(submitAndHide)">

          <validation-provider
            #default="validationContext"
            name="Module No"
            v-if="!editChapterData || !editChapterData.id"
          >
            <b-form-group label="Insert After Module">
              <v-select
                v-model="chapter_data.insert_after_module"
                :options="modules"
                label="module_name"
                :reduce="m => m"
                :get-option-label="getModuleLabel"
                placeholder="Select a module"
                :class="{
                  'is-invalid': validationContext.errors.length,
                  'is-valid': validationContext.valid && validationContext.dirty
                }"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider #default="validationContext" name="Module no"
          v-if="editChapterData && editChapterData.id"

          >
            <b-form-group label="Short Order" label-for="module-no">
              <!-- {{ chapter_data.module_no }} -->
              <b-form-input
                id="module-no"
                label="module_no"
                v-model="chapter_data.module_no"
                :reduce="m => m"
                trim
              />
              <!-- <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback> -->
            </b-form-group>
          </validation-provider>
          <validation-provider name="Parent Module" #default="validationContext">
            <b-form-group label="Parent Module (Optional)">
              <!-- {{ chapter_data.parent_module }} -->
              <v-select
                v-model="chapter_data.parent_module"
                :options="modules"
                label="module_name"
                :reduce="m => m"
                :get-option-label="getModuleLabel"
                placeholder="Select a module"
                multiple
                :class="{
                  'is-invalid': validationContext.errors.length,
                  'is-valid': validationContext.valid && validationContext.dirty
                }"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider #default="validationContext" name="Module Name">
            <b-form-group label="Module Name" label-for="module-name">
              <b-form-input
                id="module-name"
                v-model="chapter_data.module_name"
                :state="getValidationState(validationContext)"
                trim
              />
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider name="Type" v-slot="{ errors, valid, dirty }">
            <label>Select Type</label>
            <v-select
              class="w-100"
              v-model="chapter_data.module_type"
              placeholder="Select Type"
              :clearable="false"
              :options="getModuleTypeOptions()"
              label="label"
              :reduce="option => option.value"
              >
              <template #option="{ label }">
                {{ label }}
              </template>
            </v-select>
          </validation-provider>


          <div  v-if="chapter_data.module_type === 'topic'"
            class="mt-1">
            <label>Select Topic</label>
            <v-select
              v-model="chapter_data.topic"
              placeholder="Select topics"
              :options="localTopics"
              label="categoryName"
              :clearable="true"
            />
          </div>


        <validation-provider #default="validationContext" name="Chapter No">
            <b-form-group label="Chapter Title" label-for="chapter-no" v-if="chapter_data.module_type === 'chapter'" class="mt-1">
              <b-form-input
                id="chapter-no"
                v-model="chapter_data.chapter_no"
                :state="getValidationState(validationContext)"
                type="text"
                min="1"
                trim
              />
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider #default="validationContext" name="Description">
            <b-form-group label="Description" label-for="Topic-Description" v-if="chapter_data.module_type === 'chapter'" class="mt-1">
              <b-form-textarea
                id="Topic-Description"
                v-model="chapter_data.description"
                :state="getValidationState(validationContext)"
                placeholder="Enter description..."
                rows="4"
                max-rows="6"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider #default="validationContext" name="Total Question">
            <b-form-group label="Total Question" label-for="total-question" v-if="chapter_data.module_type === 'evaluation'" class="mt-1">
              <b-form-input
                id="total-question"
                v-model="chapter_data.total_question"
                :state="getValidationState(validationContext)"
                trim
              />
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider #default="validationContext" name="Estimated Time">
            <b-form-group label="Estimated Time" label-for="estimated-time"  v-if="chapter_data.module_type === 'evaluation'" class="mt-1">
                <b-form-input
                  id="estimated-time"
                  v-model="chapter_data.estimated_time"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

         <div v-if="chapter_data.module_type === 'evaluation'" class="mt-1">
            <label>Evaluation  Subjects</label>
            <v-select
                v-model="chapter_data.subjects"     
                placeholder="evaluation  Subjects"        
                :options="subjects"
                label="subjectName"
                multiple                            
                :close-on-select="false"           
                :clearable="true"
                @input="fetchTopics"
                
            />
          </div>

          <!-- <div  v-if="chapter_data.module_type === 'evaluation'"
            class="mt-1">
            <label>Evaluation Topics</label>
            <v-select
              v-model="chapter_data.topics"
              placeholder="evaluation topics"
              :options="localTopics"
              label="categoryName"
              multiple
              :close-on-select="false"
              :clearable="true"
              class="custom-v-select"
            />
          </div>    -->
          <div v-if="chapter_data.module_type === 'evaluation'" class="mt-1">
            <label>Evaluation Topics</label>
            <v-select
              v-model="chapter_data.topics"
              placeholder="evaluation topics"
              :options="localTopics"
              label="categoryName"
              multiple
              :close-on-select="false"
              :clearable="true"
              class="custom-v-select"
            />
          </div>
          <validation-provider #default="validationContext" name="Title Test">
            <b-form-group label="comprehensive Title" label-for="title-test" v-if="chapter_data.module_type === 'comprehensive'" class="mt-1">
              <b-form-input
                id="title-test"
                v-model="chapter_data.title_test"
                :state="getValidationState(validationContext)"
                trim
              />
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider #default="validationContext" name="Total Marks">
            <b-form-group label="Total Marks" label-for="total-marks" v-if="chapter_data.module_type === 'comprehensive'" class="mt-1">
              <b-form-input
                id="total-marks"
                v-model="chapter_data.total_marks"
                :state="getValidationState(validationContext)"
                trim
              />
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider #default="validationContext" name="Total Question">
            <b-form-group label="Total Question" label-for="total-question" v-if="chapter_data.module_type === 'comprehensive'" class="mt-1">
              <b-form-input
                id="total-question"
                v-model="chapter_data.total_question"
                :state="getValidationState(validationContext)"
                trim
              />
              <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider #default="validationContext" name="Estimated Time">
            <b-form-group label="Estimated Time" label-for="estimated-time"  v-if="chapter_data.module_type === 'comprehensive'" class="mt-1">
                <b-form-input
                  id="estimated-time"
                  v-model="chapter_data.estimated_time"
                  :state="getValidationState(validationContext)"
                  trim
                />
                <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <div v-if="chapter_data.module_type === 'comprehensive'" class="mt-1">
  <label>Evaluation Subjects</label>
  <v-select
    v-model="chapter_data.subjects"
    placeholder="Evaluation Subjects"
    :options="subjects"
    label="subjectName"
    multiple
    :close-on-select="false"
    :clearable="true"
    @input="fetchTopics"
  />
</div>
          <div v-if="chapter_data.module_type === 'comprehensive'" class="mt-1">
            <!-- {{ selectAllTopics }} -->
            <label>
              <input type="checkbox" v-model="selectAllTopics" @change="handleSelectAllTopics">
              Select All Topics for Selected Subjects
            </label>
          </div>

          <div v-if="chapter_data.module_type === 'comprehensive'" class="mt-1"  style="display: none;">
            <label>Evaluation Topics</label>
            <v-select
              v-model="chapter_data.topics"
              placeholder="evaluation topics"
              :options="localTopics"
              label="categoryName"
              multiple
              :close-on-select="false"
              :clearable="true"
              class="custom-v-select"
            />
          </div>
          <!-- Weightage Info -->
<b-form-group v-if="chapter_data.module_type === 'comprehensive'" label="Weightage Info" class="mt-2">
  <div
    v-for="(item, index) in chapter_data.weightages"
    :key="index"
    class="d-flex align-items-end mb-2"
  >
    <!-- Subject Dropdown -->
    <v-select
  v-model="item.subject_weightages"
  :options="subjects"
  label="subjectName"
  placeholder="Select Subject"
  class="mr-1"
  style="width: 200px"
/>
    <!-- <v-select
      v-model="item.subject_weightages"
      :options="subjects"
      label="subjectName"
      :reduce="s => s._id" 
      placeholder="Select Subject"
      class="mr-1"
      style="width: 200px"
    /> -->

    <!-- Percentage -->
    <b-form-input
      v-model="item.percentage"
      placeholder="Percentage"
      class="mr-1"
      style="width: 90px"
    />

    <!-- MCQs -->
    <b-form-input
      v-model="item.mcqs"
      placeholder="No of MCQs"
      class="mr-1"
      style="width: 110px"
    />

    <!-- Remove -->
    <b-button
      variant="danger"
      size="sm"
      class="mt-1"
      @click="removeEvaluationRow(index)"
    >
      -
    </b-button>
  </div>

  <!-- Add Button -->
  <b-button
    variant="success"
    size="sm"
    class="mt-1"
    @click="addEvaluationRow"
  >
    +
  </b-button>
</b-form-group>

          <!-- <b-form-group
            v-if="chapter_data.module_type === 'comprehensive'"
            label="Weightage Info"
            class="mt-2"
          >
            <div
              v-for="(item, index) in chapter_data.weightages"
              :key="index"
              class="d-flex align-items-end mb-2"
            >
              <v-select
                  v-model="chapter_data.subjects"
                  placeholder="Subject"
                  :options="subjects"
                />
              <b-form-input
                v-model="item.subject_weightages"
                placeholder="Subject"
                class="mr-1"
                style="width: 110px"
              />

              <b-form-input
                v-model="item.percentage"
                placeholder="Percentage"
                class="mr-1"
                style="width: 90px"
              />

              <b-form-input
                v-model="item.mcqs"
                placeholder="No of MCQs"
                class="mr-1"
                style="width: 110px"
              />

              <b-button
                variant="danger"
                size="sm"
                class="mt-1"
                @click="removeEvaluationRow(index)"
              >
                -
              </b-button>
            </div>

            <b-button
              variant="success"
              size="sm"
              class="mt-1"
              @click="addEvaluationRow"
            >
              +
            </b-button>
          </b-form-group>   -->
          <div
            class="d-flex bg-light text-light align-items px-3 py-2"
            style="position: absolute; bottom: 0%; left: 0%; width: 100%"
          >
            <b-button variant="primary" type="submit" :disabled="!chapter_data.module_no || !chapter_data.module_name || !chapter_data.module_type">
              {{ editChapterData ? 'Update' : 'Add' }}
            </b-button>
            <b-button
              variant="outline-secondary"
              type="button"
              style="margin-left: 10px"
              @click="closeSidebar()"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </span>
    </div>
    </template>
    </div>
  </b-sidebar>

</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import axios from 'axios';
import { BFormTextarea } from "bootstrap-vue";



export default {
  name: "AddNewChapter",
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BFormTextarea,

  },
  directives: {
    Ripple,
  },
  model: {
    prop: "isAddNewChapterSidebarActive",
  },
  props: {
  isAddNewChapterSidebarActive: {
    type: Boolean,
    required: true,
  },
  subjectId: {
    type: String,
    required: true,
  },
  classId:{
    type:String,
    required:true
  },
  editChapterData: {  
    type: Object,
    default: () => null
  },
  subjects:{
    type: Array,
    required: true
  },
  topics: {
    type: Array,
    required: true
  },
  modules: {
    type: Array,
    default: () => []
  },
  // selectedAddAfterModule: {
  //   type: Object,
  //   default: () => null
  // },

},
  
  data() {
    return {
      chapter_data: {
        parent_module: [],
        insert_after_module: null,
        module_no: null,
        module_name: "",
        module_type:"",
        subject: [],
        topics:[],
        estimated_time:'',
        description:'',
        total_question:'',
        chapter_no:'',
        topic:'',
        total_marks:'',
        title_test:'',
      weightages: [{
      subject_weightages: {
    _id: '',
    subjectName: ''
  },
  percentage:'' ,
  mcqs: ''}
        // { subject_weightages: '', percentage: '', mcqs: '' }
      ],
      },
      selectAllTopics: false,
      localTopics: [],
      // subjects: [],
      // topics:[],
    };
  },
  watch: {
    topics: {
    immediate: true,
    handler(newVal) {
      this.localTopics = [...newVal]; 
    }
  },
  editChapterData: {
    immediate: true,
    handler(newVal) {
      if (newVal && newVal.id) {
        // console.log("topics",newVal),
        console.log("editChapterData Changed:", newVal);
        // this.chapter_data.module_no = newVal.module_no;
        this.chapter_data.module_no = newVal.module_no;
        this.chapter_data.insert_after_module = newVal.module_no;
        // this.chapter_data.module_no = this.modules.find(m => m.module_no === newVal.module_no);
        this.chapter_data.module_name = newVal.module_name;
        this.chapter_data.module_type = newVal.module_type;
        this.chapter_data.estimated_time = newVal.estimated_time;
        this.chapter_data.subjects = newVal.subjects;
        this.chapter_data.topics = newVal.topics;
        this.chapter_data.topic = newVal.topic;
        this.chapter_data.description = newVal.description;
        this.chapter_data.chapter_no = newVal.chapter_no;
        this.chapter_data.total_question = newVal.total_question;
        this.chapter_data.total_question = newVal.total_question;
        this.chapter_data.weightages = newVal.weightages;
        this.chapter_data.title_test = newVal.title_test;
        this.chapter_data.total_marks = newVal.total_marks;



        // this.chapter_data.parent_module = this.modules.find(
        //   m => m._id === newVal.parent_module_id
        // );
        if (Array.isArray(newVal.parent_module_id)) {
            this.chapter_data.parent_module = this.modules.filter(
              m => newVal.parent_module_id.includes(m._id)
            );
          } else {
            this.chapter_data.parent_module = [];
          };
        if (
          newVal.module_type === 'evaluation' &&
          newVal.subjects &&
          newVal.subjects.length > 0
        ) {
          this.fetchTopics(newVal.subjects);
        }
      } else {
        this.resetForm();
        if (this.modules && this.modules.length > 0) {
          const lastModule = this.modules[this.modules.length - 1];
          this.chapter_data.module_no = lastModule;
        } else {
          this.chapter_data.module_no = 1;
        }
      }
    }
  },

  'chapter_data.module_type'(newType) {
    if (newType === 'chapter') {
      this.chapter_data.subjects = [];
      this.chapter_data.topics = [];
      this.chapter_data.estimated_time = null;
      this.chapter_data.total_question = null;
    } else if (newType === 'evaluation') {
      this.chapter_data.chapter_no = null;
      this.chapter_data.description = null;

      if (!this.chapter_data.subjects || this.chapter_data.subjects.length === 0) {
        const selectedSubject = this.subjects.find(s => s._id === this.subjectId);
        if (selectedSubject) {
          this.chapter_data.subjects = [selectedSubject];
          this.fetchTopics([selectedSubject]);
        }
      }
    }
  },
  'chapter_data.parent_module': {
  handler: async function (newVal) {
    // console.log("rytyiuouopipo");
    if (Array.isArray(newVal) && newVal.length > 0) {
      const moduleIds = newVal.map(m => m._id);
      const response = await axios.post(
        `${process.env.VUE_APP_API_URL}/module/fetch-evaluation-topics`,
        { moduleIds },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("_t")}`,
          }
        }
      );

      const fetchedTopicIds = response.data.topics || [];

      this.localTopics = this.topics.filter(topic =>
        fetchedTopicIds.includes(topic._id)
      );
      //  Set module_type = 'evaluation' if any selected parent module is evaluation
      const isEvaluation = newVal.some(m => m.module_type === 'evaluation');
      if (isEvaluation) {
        this.chapter_data.module_type = 'evaluation';
      }

      //  If it's already evaluation, auto-set topics
      if (this.chapter_data.module_type === 'evaluation') {
        this.chapter_data.topics = [...this.localTopics];
      }
      // if (this.chapter_data.module_type === 'evaluation') {
      //   this.chapter_data.topics = [...this.localTopics];
      // }
    } 
    // if(this.chapter_data.module_type === 'evaluation') {
    //   this.chapter_data.topics = [...this.localTopics];
    // }
    // else {
    //   this.localTopics = [];
    //   this.chapter_data.topics = [];
    // }
  },
  immediate: true
},

  },



  methods: {
    addEvaluationRow() {
    this.chapter_data.weightages.push({ subject_weightages: '', percentage: '', mcqs: '' });
  },
  removeEvaluationRow(index) {
    this.chapter_data.weightages.splice(index, 1);
  },
   getModuleLabel(option) {
  return option?.module_name || '';
},
 setDefaultInsertAfterModule() {
  if ((!this.editChapterData || !this.editChapterData.id) && this.modules.length > 0) {
    const lastModule = this.modules[this.modules.length - 1];
    this.chapter_data.module_no = lastModule.module_no + 1;
    this.chapter_data.insert_after_module = lastModule; 
    console.log("Default module set manually:", lastModule);
  } else {
    this.chapter_data.insert_after_module = null;
  }
},


  onSidebarToggle(val) {
  this.$emit('update:is-add-new-chapter-sidebar-active', val);
  if (val === true) {
    this.setDefaultInsertAfterModule();
  }
},
    fetchTopics(selectedSubjects) {
        if (!selectedSubjects || selectedSubjects.length === 0) {
        this.localTopics = [];
        this.chapter_data.topics = [];
        return; 
      }
     const subjectIds = selectedSubjects.map(s => s._id);

    axios.post(
        process.env.VUE_APP_API_URL + "/get-subject-topics",
        { subject_ids: subjectIds },
        { headers: { Authorization: "Bearer " + localStorage.getItem("_t") } }
      ).then(response => {
        const newTopics = response.data.topics;

        this.localTopics  = newTopics;

        const newTopicIds = newTopics.map(t => t._id);
        this.chapter_data.topics = this.chapter_data.topics.filter(
          selected => newTopicIds.includes(selected._id)
        );
      }).catch(error => {
        console.error("Error fetching topics:", error);
      });
    },
    handleSelectAllTopics() {
    if (!this.selectAllTopics) {
      this.chapter_data.topics = [];
      return;
    }

    const subjectIds = this.chapter_data.subjects.map(s => s._id);
    if (subjectIds.length === 0) return;

    axios.post(
      process.env.VUE_APP_API_URL + "/get-subject-topics",
      { subject_ids: subjectIds },
      { headers: { Authorization: "Bearer " + localStorage.getItem("_t") } }
    ).then(response => {
      this.localTopics = response.data.topics || [];
      this.chapter_data.topics = [...this.localTopics];
    }).catch(error => {
      console.error("Error selecting all topics:", error);
    });
  },

    getModuleTypeOptions() {
      return [
        { label: 'Chapter', value: 'chapter' },
        { label: 'Evaluation', value: 'evaluation' },
        { label: 'Topic Practice', value: 'topic' },
        { label: 'Comprehensive Test', value: 'comprehensive' },

      ];
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    resetForm() {
      this.$emit('update:editChapterData', null);      
      this.chapter_data.module_no = null;
      this.chapter_data.module_name = "";
      this.chapter_data.module_type = "";
      this.chapter_data.subjects = "";
      this.chapter_data.topics = "";
      this.chapter_data.estimated_time = "";
      this.chapter_data.total_question = "";
      this.chapter_data.description = "";
      this.chapter_data.chapter_no = "";
      this.chapter_data.topic = "";
      this.chapter_data.parent_module="";
      this.chapter_data.title_test = "";
      this.chapter_data.total_marks = "";
      this.chapter_data.weightages = [{ subject_weightages: '', percentage: '', mcqs: '' }];
    },
    onSubmit() {
  const type = this.chapter_data.module_type;
 
// let module_no = 10;

// if (!this.editChapterData || !this.editChapterData.id) {
//   const afterModule = this.chapter_data.insert_after_module;

//   if (
//     afterModule &&
//     typeof afterModule === "object" &&
//     afterModule.module_no !== undefined
//   ) {
//     const afterOrder = afterModule.module_no;

//     // insert at +1
//     module_no = afterOrder + 1;

//     // avoid conflict
//     while (this.modules.find(m => m.module_no === module_no)) {
//       module_no += 1;
//     }
//   } else {
//     const sorted = [...this.modules].sort((a, b) => b.module_no - a.module_no);
//     module_no = sorted.length ? sorted[0].module_no + 10 : 10;
//   }

//   this.chapter_data.module_no = module_no;
// }


let module_no = 10;

if (!this.editChapterData || !this.editChapterData.id) {
  const afterModule = this.chapter_data.insert_after_module;

  if (
    afterModule &&
    typeof afterModule === "object" &&
    afterModule.module_no !== undefined
  ) {
    const isLast =
      this.modules.length &&
      afterModule._id === this.modules[this.modules.length - 1]._id;

    // Logic:
    // if last module selected → +10
    // else → +1
    const afterOrder = afterModule.module_no;
    module_no = isLast ? afterOrder + 10 : afterOrder + 1;

    // avoid conflict
    while (this.modules.find(m => m.module_no === module_no)) {
      module_no += 1;
    }
  } else {
    // default case if nothing selected
    const sorted = [...this.modules].sort((a, b) => b.module_no - a.module_no);
    module_no = sorted.length ? sorted[0].module_no + 10 : 10;
  }

  this.chapter_data.module_no = module_no;
}



//   let module_no = 10; // default

// const afterModule = this.chapter_data.module_no;

//     if (
//       afterModule &&
//       typeof afterModule === "object" &&
//       afterModule.module_no !== undefined
//     ) {
//       const afterOrder = afterModule.module_no;

//       // Find the next module (right after the selected "insert after")
//         const sortedModules = [...this.modules].sort((a, b) => a.module_no - b.module_no);
//         const currentIndex = sortedModules.findIndex(m => m.module_no === afterOrder);
//         const nextModule = sortedModules[currentIndex + 1];

//         if (nextModule) {
//           const nextOrder = nextModule.module_no;
//           module_no = Math.floor((afterOrder + nextOrder) / 2);
//         } else {
//           // Insert at end
//           module_no = afterOrder + 10;
//         }
//       }

  const payload = {
    module_no: Number(this.chapter_data.module_no),
    module_name: this.chapter_data.module_name,
    module_type: type,
    subject_id: this.subjectId,
    // parent_module_id:this.chapter_data.parent_module.map(pm => pm._id) || null,
    classId: this.classId,
    parent_module_id: Array.isArray(this.chapter_data.parent_module)
  ? this.chapter_data.parent_module.map(pm => pm._id)
  : this.chapter_data.parent_module?._id
    ? [this.chapter_data.parent_module._id]
    : null,
    subject_ids: (type === 'comprehensive' || type === 'evaluation') && this.chapter_data.subjects?.length
      ? this.chapter_data.subjects.map(s => s._id)
      : null,
    topic_ids: (type === 'comprehensive' || type === 'evaluation') && this.chapter_data.topics?.length
      ? this.chapter_data.topics.map(t => t._id)
      : null,

     weightages: this.chapter_data.weightages?.length
  ? this.chapter_data.weightages.map(w => ({
      subject_weightages: {
        subjectId: w.subject_weightages?._id,
        subjectName: w.subject_weightages?.subjectName
      },
      percentage: w.percentage,
      mcqs: w.mcqs
    }))
  : null,
  //     weightages: this.chapter_data.weightages && this.chapter_data.weightages.length
  // ? JSON.parse(JSON.stringify(this.chapter_data.weightages))
  // : null,

      title_test: type === 'comprehensive' ? this.chapter_data.title_test : null,
      total_marks: type === 'comprehensive' ? this.chapter_data.total_marks : null,


      
    topicId: type === 'topic' && this.chapter_data.topic
    ? Array.isArray(this.chapter_data.topic)
      ? this.chapter_data.topic[0]?._id
      : this.chapter_data.topic._id
    : null,

    estimated_time:(type === 'comprehensive' || type === 'evaluation') ? this.chapter_data.estimated_time : null,
    total_question:(type === 'comprehensive' || type === 'evaluation') ? this.chapter_data.total_question : null,
    description: type === 'chapter' ? this.chapter_data.description : null,
    chapter_no: type === 'chapter' ? this.chapter_data.chapter_no : null,
  };
  console.log('payload' ,payload);
  if (this.editChapterData && this.editChapterData.id) {
    payload.id = this.editChapterData.id;
    this.$emit("editmoduledata", payload);
  } else {
    this.$emit("sendmoduledata", payload);
  }
},

     
    submitAndHide() {
      this.onSubmit();
      this.$emit("update:is-add-new-chapter-sidebar-active", false);
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
  },
};
</script>
<style scoped>

.modal-scroll-wrapper {
  max-height: 90vh;
  overflow-y: auto;
  padding-right: 10px;
}

.modal-scroll-wrapper::-webkit-scrollbar {
  width: 12px;
}

.modal-scroll-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 6px;
}

.modal-scroll-wrapper::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 6px;
}

.modal-scroll-wrapper::-webkit-scrollbar-thumb:hover {
  background: #999;
}

/* Firefox */
.modal-scroll-wrapper {
  scrollbar-width: thin;
  scrollbar-color: #ccc #f1f1f1;
}

</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>

